(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["replica-product-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-replica-gallery]').forEach(function (gallery) {
      var slides = gallery.querySelectorAll('.rh-main-slide');
      var thumbs = gallery.querySelectorAll('.rh-thumb');
      var prev = gallery.querySelector('.rh-main-arrow--prev');
      var next = gallery.querySelector('.rh-main-arrow--next');
      if (slides.length === 0) return;
      function activeIndex() {
        for (var i = 0; i < slides.length; i++) if (slides[i].classList.contains('is-active')) return i;
        return 0;
      }
      function activate(i) {
        var c = (i + slides.length) % slides.length;
        slides.forEach(function (s, idx) { s.classList.toggle('is-active', idx === c); });
        thumbs.forEach(function (t, idx) { t.classList.toggle('is-active', idx === c); });
        var activeThumb = thumbs[c];
        if (activeThumb && activeThumb.scrollIntoView) activeThumb.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
      }
      thumbs.forEach(function (t) { t.addEventListener('click', function () { activate(parseInt(t.dataset.index, 10)); }); });
      if (prev) prev.addEventListener('click', function () { activate(activeIndex() - 1); });
      if (next) next.addEventListener('click', function () { activate(activeIndex() + 1); });
      var main = gallery.querySelector('.rh-main');
      if (main) {
        var x0 = 0, y0 = 0, dx = 0, dir = 0, lock = null, incoming = null;
        function W() { return main.getBoundingClientRect().width; }
        function slideAt(n) { return slides[(n + slides.length) % slides.length]; }
        function clearInline() {
          slides.forEach(function (s) { s.style.transform = ''; s.style.opacity = ''; s.style.transition = ''; });
        }
        main.addEventListener('touchstart', function (e) {
          x0 = e.touches[0].clientX; y0 = e.touches[0].clientY;
          dx = 0; lock = null; incoming = null;
        }, { passive: true });
        main.addEventListener('touchmove', function (e) {
          var mx = e.touches[0].clientX - x0;
          var my = e.touches[0].clientY - y0;
          if (lock === null) {
            if (Math.abs(mx) > 10 && Math.abs(mx) > Math.abs(my)) lock = true;
            else if (Math.abs(my) > 10) lock = false;
          }
          if (lock !== true) return;
          dx = mx;
          var d = dx < 0 ? 1 : -1;
          if (d !== dir || !incoming) {
            if (incoming) { incoming.style.transform = ''; incoming.style.opacity = ''; }
            dir = d;
            incoming = slideAt(activeIndex() + dir);
          }
          var active = slides[activeIndex()];
          active.style.transition = 'none';
          incoming.style.transition = 'none';
          incoming.style.opacity = '1';
          active.style.transform = 'translateX(' + dx + 'px)';
          incoming.style.transform = 'translateX(' + (dx + dir * W()) + 'px)';
        }, { passive: true });
        main.addEventListener('touchend', function () {
          if (lock !== true || !incoming) { clearInline(); lock = null; return; }
          var from = activeIndex();
          var active = slides[from];
          var commit = Math.abs(dx) > Math.min(80, W() / 4);
          active.style.transition = 'transform .25s ease';
          incoming.style.transition = 'transform .25s ease';
          if (commit) {
            active.style.transform = 'translateX(' + (-dir * W()) + 'px)';
            incoming.style.transform = 'translateX(0)';
            setTimeout(function () { activate(from + dir); clearInline(); }, 260);
          } else {
            active.style.transform = 'translateX(0)';
            incoming.style.transform = 'translateX(' + (dir * W()) + 'px)';
            setTimeout(clearInline, 260);
          }
          lock = null;
        }, { passive: true });
        main.addEventListener('touchcancel', function () { clearInline(); lock = null; }, { passive: true });
      }
      activate(0);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
